import { useApiClient } from '@/api/client'

export const FIRESTORE_CONFIG_FOR_WEB = '/core/v2/business_api/firestore/config/web/' as const

export function getFirestoreConfigForWeb () {
  const apiClient = useApiClient()

  return apiClient.post({
    url: FIRESTORE_CONFIG_FOR_WEB,
  })
}
